import React from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import Button from '../ui/Button';
import { useNavigate } from '@tanstack/react-router';

const ApiDocs: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-slate-900 min-h-screen text-slate-300 font-sans antialiased">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 py-24 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center px-3 py-1 rounded-full border border-sky-500/30 bg-sky-500/10 text-sky-400 text-xs font-bold mb-6 uppercase">
            Developer Preview
          </div>
          <h1 className="text-4xl font-bold text-white mb-6">API Documentation</h1>
          <p className="text-lg text-slate-400 mb-8">
            We are currently finalizing our public API documentation.
            Access is currently available to Enterprise partners and Beta testers.
          </p>
          <div className="flex justify-center gap-4">
            <Button onClick={() => window.location.href = 'mailto:support@progeodata.com'}>
              Request Access
            </Button>
            <Button variant="secondary" onClick={() => navigate({ to: '/' })}>
              Back to Home
            </Button>
          </div>
        </div>

        <div className="mt-20 max-w-4xl mx-auto border border-slate-800 rounded-xl overflow-hidden bg-slate-950 shadow-2xl">
          <div className="bg-slate-900 p-4 border-b border-slate-800 flex items-center">
            <div className="flex space-x-2 mr-4">
              <div className="w-3 h-3 rounded-full bg-red-500"></div>
              <div className="w-3 h-3 rounded-full bg-yellow-500"></div>
              <div className="w-3 h-3 rounded-full bg-green-500"></div>
            </div>
            <div className="text-xs text-slate-500 font-mono">example_request.sh</div>
          </div>
          <div className="p-6 overflow-x-auto">
            <pre className="text-sm font-mono text-slate-300">
              <span className="text-purple-400">curl</span> -X GET \<br />
              <span className="text-green-400">'https://api.progeodata.com/v1/professionals/search?zip=90210&type=real_estate_agent'</span> \<br />
              -H <span className="text-green-400">'Authorization: Bearer YOUR_API_KEY'</span>
            </pre>
          </div>
        </div>

      </div>
      <Footer />
    </div>
  );
};

export default ApiDocs;